import { motion } from "framer-motion";
import content from "../content";

export default function PastorSection() {
  const { pastor } = content;

  return (
    <section id="pastor" className="relative w-full bg-electric py-28 md:py-36 overflow-hidden" data-testid="pastor-section">
      {/* subtle texture */}
      <div
        className="pointer-events-none absolute inset-0 opacity-30"
        style={{ background: "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.18), transparent 45%)" }}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-4xl mx-auto px-6">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-poppins text-xs md:text-sm tracking-[0.35em] uppercase text-white/80 font-semibold text-center mb-10"
        >
          {pastor.eyebrow}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 40, scale: 0.97 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative bg-white rounded-[2.25rem] p-8 md:p-14 shadow-[0_40px_100px_-30px_rgba(0,0,0,0.55)]"
          data-testid="pastor-card"
        >
          {/* speech-bubble tail */}
          <span className="absolute -bottom-4 left-12 w-8 h-8 bg-white rotate-45 rounded-sm" aria-hidden="true" />

          <p className="font-poppins text-ink text-lg md:text-2xl leading-relaxed">
            {pastor.quote}
          </p>

          <div className="flex items-center gap-4 mt-9">
            <div className="w-14 h-14 rounded-full bg-electric flex items-center justify-center font-anton text-white text-xl shadow-[0_0_20px_rgba(33,112,232,0.5)]">
              {pastor.initials}
            </div>
            <div>
              <p className="font-anton uppercase text-ink text-xl leading-none tracking-tight">
                {pastor.name}
              </p>
              <p className="font-poppins text-ink/60 text-sm mt-1">{pastor.role}</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
